import React from 'react';

/**
 * @export 携带参数跳转组件
 * @class RedirectWithQuery
 * @extends {React.Component}
 */
export default class RedirectWithQuery extends React.Component {
  render() {
    const { location, history, target } = this.props;
    const { search } = location;

    setTimeout(() => {
      history.push({
        pathname: target || '/entrance',
        search,
      });
    });

    return null;
  }
}
